$(document).ready(function () {
  $('.slick-ctn').slick({
    autoplay: true,
  });

  $('.text-banner-widget .text-banner-widget_frame #TextBanner').css(
    'margin',
    '0'
  );

  $('ul.custom_grid').attr('data-layout', 'custom_grid');

  let addedOr = false;

  // PLANTERS PICKER INITILISATION
  let planterAmount;
  const currentProductId = localStorage.getItem('current-product-id');

  const mediaQuery = window.matchMedia('(min-width: 769px)');

  // Check if the media query is true
  if (mediaQuery.matches) {
    planterAmount = 3;
  } else {
    planterAmount = 2;
  }

  if (window.screen.width <= 1024) {
    $('#text-banner-widget').appendTo('.top-banner-mobile');
  }

  // if change theme, update this selector to the corresponding option for size
  const option1 = $(
    '.options-selection__radios:not(.visibility-hidden) .options-selection__option-value-name'
  );
  const onlyOneSize =
    $('.options-selection__option-values.Size').children().length == 1;

  if (onlyOneSize) {
    setTimeout(function () {
      onlySizeClick();
    }, 1000);
  }

  option1.each(function () {
    addToCartForm = $(`#product_form_${currentProductId}`);
    if ($(this).hasClass('options-selection__option-value--selected')) {
      currentOption = $(this).text().trim();
    }

    $(this).on('click', function () {
      currentOption = $(this).text().trim();

      optionStatus = $(this).attr('datastatus');

      $(`.planters-picker`).each(function () {
        if ($(this).attr('dataPlanter') === currentOption) {
          $(this).removeClass('hidden');
        } else {
          $(this).addClass('hidden');
        }
      });

      $(`.notify-form`).each(function () {
        if ($(this).attr('dataPlanter') === currentOption) {
          $(this).removeClass('hidden');
        } else {
          $(this).addClass('hidden');
        }
      });

      $(`.out-of-stock-btn`).each(function () {
        if ($(this).attr('dataPlanter') === currentOption) {
          $(this).removeClass('hidden');
        } else {
          $(this).addClass('hidden');
        }
      });

      $(`.or-hr`).each(function () {
        if ($(this).attr('dataPlanter') === currentOption) {
          $(this).removeClass('hidden');
        } else {
          $(this).addClass('hidden');
        }
      });

      $(
        `.planters-picker[dataPlanter='${currentOption}'] .planter-item:not('.see-all')`
      ).hide();
      $(
        `.planters-picker[dataPlanter='${currentOption}'] .planter-item:lt(${planterAmount})`
      ).show();

      $(`.planters-picker.planters-picked`).css('display', 'none');

      $('.planter-input').each(function () {
        $(this).remove();
      });

      let count =
        $(
          `.planters-picker[dataPlanter="${currentOption}"] .planter-item:not(".see-all")`
        ).length - planterAmount;

      $(`p[dataPlanter="${currentOption}"]`).text(`(${count} more options)`);

      $('.custom-accordion-ctn').css('display', 'none');
      $(`.custom-accordion-ctn[dataPlanter="${currentOption}"]`).css(
        'display',
        'block'
      );

      updateStatus(optionStatus);
    });
  });

  var coll = document.getElementsByClassName('custom-collapsible');
  var i;

  for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener('click', function () {
      this.classList.toggle('active');
      var content = this.nextElementSibling;
      if (content.style.display === 'block') {
        content.style.display = 'none';
      } else {
        content.style.display = 'block';
      }
    });
  }

  // Custom accordion for pre-order
  var accordion = document.getElementsByClassName('custom-accordion');
  var i;

  for (i = 0; i < accordion.length; i++) {
    accordion[i].addEventListener('click', function () {
      /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
      this.classList.toggle('accordion-active');

      /* Toggle between hiding and showing the active panel */
      var panel = this.nextElementSibling;
      if (panel.style.display === 'block') {
        panel.style.display = 'none';
      } else {
        panel.style.display = 'block';
      }
    });
  }

  const allVariantsMedia = localStorage.getItem('variants-media-id').split(';');
  click();
});
const outStockImg = localStorage.getItem('variants-media-id');

function click() {
  // const firstAvailable = option1.filter(
  //   (option) => !option.attr("datastatus").includes("Unavailable")
  // );
  // console.log(firstAvailable);
  const firstAvailable = option1.filter(function () {
    return $(this).attr('datastatus').includes('Unavailable') == false;
  });
  if (firstAvailable[0] == option1[0]) {
    option1[1].click();
    option1[0].click();
  } else {
    firstAvailable[0].click();
  }

  // option1[1].click(function () {
  //   console.log("clicked");
  // });
  // if (!option1[0].attr("datastatus").includes("Unavailable")) {
  //   option1[0].click();
  // } else {
  //   console.log("first option unavailable");
  // }
}

function onlySizeClick() {
  $('.options-selection__option-values.Size')
    .find('.options-selection__option-value-name')
    .eq(0)
    .click();
}

let currentOption;
let optionStatus;

let addToCartForm;

function updateStatus(status) {
  if (status.includes('Unavailable')) {
    $('.product-form--atc').addClass('hidden');
  }
  if (status.includes('Pre-order')) {
    $('.product-form--atc').removeClass('hidden');
    $('.product-form--atc .product-form--atc-button').attr(
      'data-product-atc-preorder',
      ''
    );
    $(".product-form--atc .product-form--atc-button[type='submit']").html(
      'Pre-order'
    );
  }
  if (status.includes('Available')) {
    $('.product-form--atc').removeClass('hidden');
    $('.product-form--atc .product-form--atc-button').removeAttr(
      'data-product-atc-preorder'
    );
    $(".product-form--atc .product-form--atc-button[type='submit']").html(
      'Add To Cart'
    );
  }
}

const option1 = $(
  '.options-selection__radios:not(.visibility-hidden) .options-selection__option-value-name'
);
option1.each(function () {
  if ($(this).hasClass('options-selection__option-value--selected')) {
    currentOption = $(this).text();
  }
  $(this).on('click', function () {
    currentOption = $(this).text();
    optionStatus = $(this).attr('datastatus');
  });
});

/* Open */
function openNav(element) {
  document.getElementById(`${currentOption}-plantersOverlay`).style.display =
    'block';
  $(
    `.planters-overlay-planters-wrap[dataPlanter="${currentOption}"] .planter-item`
  )[0].click();

  $('.site-announcement, header').css('display', 'none');
}

/* Close */
function closeNav() {
  document.getElementById(`${currentOption}-plantersOverlay`).style.display =
    'none';
  $('.planter-item').each(function () {
    $(this).removeClass('planter-selected');
    $('.site-announcement, header').css('display', 'initial');
  });
}

function updateImg(
  img_url,
  planter_id,
  planter_price,
  planter_name,
  product_url
) {
  const allPlantersItems = document.querySelectorAll('.planter-item');
  allPlantersItems.forEach((item, index) => {
    item.classList.remove('planter-selected');
  });
  document.getElementById(`${currentOption}-planterImgOverlay`).src = img_url;
  document.querySelectorAll(`.planter-${planter_id}`).forEach((item, index) => {
    item.classList.add('planter-selected');
  });
  localStorage.setItem(
    'current-planter',
    `${planter_id}, ${planter_price}, ${img_url}, ${planter_name}, ${product_url}`
  );
}

function selectPlanter() {
  $('.planter-input').each(function () {
    $(this).remove();
  });
  const planter = localStorage.getItem('current-planter').split(', ');
  $(`.planters-picker.planters-picked[dataPlanter="${currentOption}"]`).css(
    'display',
    'flex'
  );
  document.getElementById(`${currentOption}-pickedImg`).src = planter[2];
  document.getElementById(`${currentOption}-pickedPrice`).textContent =
    planter[1];
  $('.planters-picker:not(.planters-picked)').each(function () {
    $(this).addClass('hidden');
  });

  const planterId = localStorage.getItem('current-planter').split(', ')[0];
  const planterName = localStorage.getItem('current-planter').split(', ')[3];
  const planterUrl = localStorage.getItem('current-planter').split(', ')[4];
  $(`.picked-name[dataPlanter="${currentOption}"]`)
    .text(`${planterName}`)
    .attr('href', planterUrl);
  $(
    `<input class="planter-input" type="hidden" name="items[0][quantity]" value="1"> <input class="planter-input" type="hidden" name="items[0][id]" value="${planterId}">`
  ).appendTo(addToCartForm);
  closeNav();
}

function removePlanter() {
  $('.planter-input').each(function () {
    $(this).remove();
  });
  const allPlantersItems = document.querySelectorAll('.planter-item');
  allPlantersItems.forEach((item, index) => {
    item.classList.remove('planter-selected');
  });
  localStorage.removeItem('current-planter');
  $(
    `.planters-picker[dataPlanter="${currentOption}"]:not(.planters-picked)`
  ).each(function () {
    $(this).removeClass('hidden');
  });
  $(`.planters-picker.planters-picked`).css('display', 'none');
}

// CUSTOM TABS SELECT
function tabSelect(evt, contentID, sectionID) {
  let i, tabcontent, tablinks, tabCtn;
  tabcontent = document.querySelectorAll(`${sectionID} .tabcontent`);
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = 'none';
  }

  tablinks = document.querySelectorAll(`${sectionID} .tablinks`);
  tabCtn = document.querySelectorAll(`${sectionID} .tab`);
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(' active', '');
    tabCtn[i].className = tabCtn[i].className.replace(' active', '');
  }

  document.getElementById(contentID).style.display = 'block';
  evt.currentTarget.className += ' active';
  evt.currentTarget.parentElement.className += ' active';
}

let tabLinks = document.querySelectorAll("a[id^='defaultOpen-']");

tabLinks.forEach((link) => {
  link.click();
});

function imagePreview(img) {
  let expandImg = img.parentElement.previousElementSibling.children[0];
  let allImgs = img.parentElement.children;

  for (let img of allImgs) {
    img.style.border = 'none';
  }

  img.style.border = '1px solid black';
  expandImg.src = img.src;
}

//Display image when select size
const $galleryViewer = $(
  '.product-gallery--viewer:not(.product-gallery--viewer-multiple-lifestyle-images-false)'
);
$galleryViewer.attr('data-disable-flickity', '');
$(".options-selection__option-value-input[Name='Size'").each(function () {
  const mediaId = $(this).attr('data-media-value').trim();
  $(this).on('click', function () {
    $(
      '.product-gallery--viewer:not(.product-gallery--viewer-multiple-lifestyle-images-false) figure.product-gallery--image'
    )
      .attr('data-gallery-selected', false)
      .removeClass('is-selected')
      .attr('aria-hidden', true);
    $(`figure.product-gallery--image[data-media='${mediaId}']`)
      .attr('data-gallery-selected', true)
      .addClass('is-selected')
      .attr('aria-hidden', false);
    // $(`button.product-gallery--media-thumbnail[data-media='${mediaId}']`).click()
    $('[data-gallery-viewer]').attr('data-media-current', mediaId);
    // $(".flickity-slider").css("transform", "translateX(0)")
  });
});

$('.product-gallery--media-thumbnail').each(function () {
  const mediaId = $(this).attr('data-media').trim();
  $(this).on('click', function () {
    $('.product-gallery--viewer figure.product-gallery--image')
      .attr('data-gallery-selected', false)
      .removeClass('is-selected')
      .attr('aria-hidden', true);
    $(`figure.product-gallery--image[data-media='${mediaId}']`)
      .attr('data-gallery-selected', true)
      .addClass('is-selected')
      .attr('aria-hidden', false);
  });
});

$('#devPromo').on('input', function (e) {
  $('#promoSave').prop('disabled', false);
  let discountCode = $(this).val();
  $("form[aria-label='cart checkout']").each(function () {
    const action = $(this).attr('action');
    $(this).attr('action', `/cart?&discount=${discountCode}`);
  });
});

$('#promoSave').on('click', function (e) {
  e.preventDefault();
  $(this).prop('disabled', true);
  console.log('Saving promo');
});
